// extracted by mini-css-extract-plugin
export default {"userAvatar":"avatars_userAvatar__qYCI6","profileAvatar":"avatars_profileAvatar__fpKQ2"};